import React from "react";
import "./Skills.css";
import {Link} from 'react-router-dom'
import DisclaimerHome from "../../components/Disclaimer/DisclaimerHome";

export default function Skills(props) {
  const handleSubmit = (e) => {
    e.preventDefault();
  };
  
  return (
    <>
      <div className="financial-goals-section container">
  <div className="text-center">
    <h2>A one-stop shop for your financial goals</h2>
  </div>
  <div className="row">
    <div className="col-md-4">
      <div className="financial-block card">
        <h3>Long-term Investing</h3>
        <p>Take aim at your future goals with an online experience.</p>
        <ul>
          <li>Easy-to-use website</li>
          <li>Broad range of account types</li>
          <li>Insightful education and guidance</li>
        </ul>
        <Link  to="/services/advistory">Learn more</Link>
      </div>
    </div>

    <div className="col-md-4">
      <div className="financial-block card">
        <h3>Trading</h3>
        <p>Master the markets with resources designed for passionate traders</p>
        <ul>
          <li>Options contracts futures contracts</li>
          <li>Robust tools and dynamic charts</li>
          <li>Specialized trading support</li>
        </ul>
        {/* <a href="#learn-more">Learn more</a> */}
        <Link  to="/home">Learn more</Link>
      </div>
    </div>

    <div className="col-md-4">
      <div className="financial-block card">
        <h3>Savings and Checking</h3>
        <p>Get convenient, low-fee banking from Morgan Stanley Private Bank.</p>
        <ul>
          <li>FDIC Protection & Free Transfers</li>
          <li>Free cash transfers</li>
          <li>Competitive rates</li>
        </ul>
        {/* <a href="#learn-more">Learn more</a> */}
        <Link  to="/services/insurance">Learn more</Link>
      </div>
    </div>
  </div>
</div>

    <br />
    <br />
      <div className="newsletter-section">
        <div className="newsletter-overlay"></div>
        <DisclaimerHome/>
        {/* <div className="newsletter-content">
          <h2>Subscribe to Our Newsletter</h2>
          <p>Stay updated with our latest news and promotions.</p>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="email"
                className="form-control"
                placeholder="Enter your email"
                required
              />
            </div>
            <button type="submit" className="newletter-btn-primary">
              Subscribe
            </button>
          </form>
        </div> */}
      </div>
      </>
  );
}
